const docMissingCompanyStatus = {
  text: 'EMPRESA BLOQUEADA MANUALMENTE'
};

export default docMissingCompanyStatus;
